module.exports = __webpack_public_path__ + "assets/test-img.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test-img.jpg
// module id = 1672
// module chunks = 7